import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import { NAME } from './constants';
import Root from './root';
import UserProfile from './containers/UserProfile';
import UpdateVendor from './containers/UpdateVendor';

export default function () {
  return (
    <Route path={NAME} component={Root}>
      <IndexRedirect to='user' />
      <Route path='user' component={UserProfile} />
      <Route path='vendor' component={UpdateVendor} />
    </Route>
  );
}
